import { render, staticRenderFns } from "./SidebarRight.vue?vue&type=template&id=171a7dd2&scoped=true&"
import script from "./SidebarRight.vue?vue&type=script&lang=js&"
export * from "./SidebarRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171a7dd2",
  null
  
)

export default component.exports